import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import {INVESTMENT_CONSTANTS} from '../../constants';


const HeaderComponent =(props)=>{
  const { ideaType, teaser, date, assestType, read, assetColorcode } = props.item
  const {itemClick,i18n: { messages }} = props;
  const backGroundColorIdeaType = ideaType === INVESTMENT_CONSTANTS.BUY ? "buy-color" :  ideaType === INVESTMENT_CONSTANTS.SELL ? "sell-color" : "switch-color"
  const teaserColor = read ===  INVESTMENT_CONSTANTS.READ ? "read-color": "unread-color"

  return (
     // styles with styles.css file

    <div onClick={itemClick} className="main-height">

      <div className={`header-component-container`} style={{backgroundColor:assetColorcode}}>
        <div className="header-ideaType">
          <div className={`header-ideaText ${backGroundColorIdeaType}`}>
            {ideaType}
          </div>
        </div>
        <div className="header-assest">
          <div className="header-assest-text">
            {assestType}
          </div>
        </div>
      </div>
      {/* add later code */}
      <div className="inner-div">
        <div className="inner-teaser-view">
          <Text className={`text-teaser ${teaserColor}`}>{teaser}</Text>
        </div>
        <div className={`date-view`}>
          <Text className={`date-text`}>{date}</Text>
        </div>
      </div>
    </div>

  );

}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(HeaderComponent);
